var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _c("header", { staticClass: "pb-4" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row align-items-end" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-auto col-12 mt-4 mt-sm-0" }, [
            _c("div", { staticClass: "hstack gap-2 justify-content-sm-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-success px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.SAVE()
                    },
                  },
                },
                [
                  _vm.count == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Guardar cambios")]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "vstack gap-4" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-4" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.name,
                              expression: "data.name",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "name", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.name, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre comercial"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.tradename,
                              expression: "data.tradename",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.tradename ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.tradename },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "tradename",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.tradename, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre internacional"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.international_name,
                              expression: "data.international_name",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.international_name
                            ? "is-invalid"
                            : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.international_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "international_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.international_name,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Cédula Jurídica"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.legal_id,
                              expression: "data.legal_id",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.legal_id ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.legal_id },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "legal_id",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.legal_id, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Sitio web"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.site,
                              expression: "data.site",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.site ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.site },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "site", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.site, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-3" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Tipo de cambio"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.exchange_rate,
                              expression: "data.exchange_rate",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.exchange_rate ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.exchange_rate },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "exchange_rate",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.exchange_rate,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12" }),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-4" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email,
                              expression: "data.email",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "email", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.email, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico soporte"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email_suport,
                              expression: "data.email_suport",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email_suport ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email_suport },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "email_suport",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.email_suport,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico información"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email_info,
                              expression: "data.email_info",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email_info ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email_info },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "email_info",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.email_info, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Dirección"),
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address,
                              expression: "data.address",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.address ? "is-invalid" : "",
                          domProps: { value: _vm.data.address },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "address", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.address, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Teléfono"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.phone,
                              expression: "data.phone",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.phone ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.phone },
                          on: {
                            keypress: _vm.NUMBER,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "phone", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.phone, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-4" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email_miami,
                              expression: "data.email_miami",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email_miami ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email_miami },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "email_miami",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.email_miami, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico soporte"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email_suport_miami,
                              expression: "data.email_suport_miami",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email_suport_miami
                            ? "is-invalid"
                            : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email_suport_miami },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "email_suport_miami",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.email_suport_miami,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico información"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.email_info_miami,
                              expression: "data.email_info_miami",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.email_info_miami
                            ? "is-invalid"
                            : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.email_info_miami },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "email_info_miami",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.email_info_miami,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Dirección"),
                        ]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.address_miami,
                              expression: "data.address_miami",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.address_miami ? "is-invalid" : "",
                          domProps: { value: _vm.data.address_miami },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "address_miami",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.address_miami,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Teléfono"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.phone_miami,
                              expression: "data.phone_miami",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.phone_miami ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.phone_miami },
                          on: {
                            keypress: _vm.NUMBER,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "phone_miami",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.phone_miami, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-3" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Tarifa"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.tarifa,
                              expression: "data.tarifa",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.tarifa ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.tarifa },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "tarifa", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.tarifa, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico emisor"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.emisor_mail,
                              expression: "data.emisor_mail",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.emisor_mail ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.emisor_mail },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "emisor_mail",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.emisor_mail, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre emisor"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.emisor_name,
                              expression: "data.emisor_name",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.emisor_name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.emisor_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "emisor_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.emisor_name, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo electrónico reporta fel"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.report_fel_email,
                              expression: "data.report_fel_email",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.report_fel_email
                            ? "is-invalid"
                            : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.report_fel_email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "report_fel_email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.report_fel_email,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre reporta fel"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.report_fel_name,
                              expression: "data.report_fel_name",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.report_fel_name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.report_fel_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "report_fel_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.report_fel_name,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Correo de soporte"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.support_email,
                              expression: "data.support_email",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.support_email ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.support_email },
                          on: {
                            keypress: _vm.NUMBER,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "support_email",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.support_email,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Nombre de soporte"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.support_name,
                              expression: "data.support_name",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.support_name ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.support_name },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "support_name",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(
                          _vm.errors.support_name,
                          function (error, index) {
                            return _c(
                              "small",
                              { key: index, staticClass: "invalid-feedback" },
                              [_vm._v(_vm._s(error))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "card mb-3" }, [
                _c("div", { staticClass: "card-body px-0 py-2" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Facebook"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.facebook,
                              expression: "data.facebook",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.facebook ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.facebook },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "facebook",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.facebook, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Instagram"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.instagram,
                              expression: "data.instagram",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.instagram ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.instagram },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "instagram",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.instagram, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Twiter"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.twiter,
                              expression: "data.twiter",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.twiter ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.twiter },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.data, "twiter", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.twiter, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6 mb-2" },
                      [
                        _c("small", { staticClass: "input-title" }, [
                          _vm._v("Linkedin"),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.data.linkedin,
                              expression: "data.linkedin",
                            },
                          ],
                          staticClass: "form-control form-control-sm",
                          class: _vm.errors.linkedin ? "is-invalid" : "",
                          attrs: { type: "text" },
                          domProps: { value: _vm.data.linkedin },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.data,
                                "linkedin",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.errors.linkedin, function (error, index) {
                          return _c(
                            "small",
                            { key: index, staticClass: "invalid-feedback" },
                            [_vm._v(_vm._s(error))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm col-12" }, [
      _c("h1", { staticClass: "h2 ls-tight" }, [_vm._v("Ajustes Generales")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Datos Generales")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Tipo de cambio")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Datos Costa Rica")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Datos Miami")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Factura electrónica")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col px-0 mb-2" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v("Redes sociales")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }